/**
 * ================================================================================
 * COMPONENTE: Header
 * PROPÓSITO: Barra superior fixa com título da página, notificações e menu mobile
 * ================================================================================
 */
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Bell, Menu, Eye, EyeOff } from 'lucide-react';
import { useFinance } from '../../context/FinanceContext';
import NotificationPanel from '../notifications/NotificationPanel';

export default function Header() {
  const { unreadCount, toggleSidebar, fetchNotifications } = useFinance();
  const location = useLocation();
  const [showNotifications, setShowNotifications] = useState(false);
  const [showBalance, setShowBalance] = useState(true);

  // Buscar notificações ao abrir painel
  useEffect(() => {
    if (showNotifications) fetchNotifications();
  }, [showNotifications, fetchNotifications]);

  useEffect(() => {
    document.documentElement.toggleAttribute('data-hide-balances', !showBalance);

    return () => {
      document.documentElement.removeAttribute('data-hide-balances');
    };
  }, [showBalance]);

  return (
    <>
      <header className="header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {/* Menu hamburger (mobile) */}
          <button
            className="header-btn"
            onClick={toggleSidebar}
            style={{ display: 'none' }}
            id="menu-toggle"
            aria-label="Abrir menu"
          >
            <Menu size={20} />
          </button>
        </div>

        <div className="header-right">
          {/* Eye toggle (mostrar/ocultar saldos) */}
          <button
            className="header-btn"
            onClick={() => setShowBalance(!showBalance)}
            title={showBalance ? 'Ocultar saldos' : 'Mostrar saldos'}
            aria-label={showBalance ? 'Ocultar saldos' : 'Mostrar saldos'}
            aria-pressed={!showBalance}
          >
            {showBalance ? <Eye size={18} /> : <EyeOff size={18} />}
          </button>

          {/* Notificações */}
          <button
            className="header-btn"
            onClick={() => setShowNotifications(!showNotifications)}
            aria-label="Abrir notificacoes"
            aria-expanded={showNotifications}
          >
            <Bell size={18} />
            {unreadCount > 0 && (
              <span className="header-btn-badge">{unreadCount}</span>
            )}
          </button>
        </div>
      </header>

      {/* Painel de notificações */}
      {showNotifications && (
        <NotificationPanel onClose={() => setShowNotifications(false)} />
      )}

      {/* CSS para mobile menu toggle */}
      <style>{`
        @media (max-width: 1024px) {
          #menu-toggle { display: flex !important; }
        }
      `}</style>
    </>
  );
}
